import { IStore } from '@/store/types';
import { IModuleState } from './types';
import * as actions from './actions';
import * as mutations from './mutations';

const initialState = {
  sectionBarPage: { data: [], pageNum: 0, pageSize: 0, total: 0, loading: false },
  sectionBarDetail: { data: null, loading: false },
  thumb: { data: null, loading: false },
  confirm: { title: '', content: '', type: '', visible: false, loading: false },
  search: { pageNum: 1, pageSize: 10 },
  loading: false,
};

export default { namespaced: true, state: initialState, actions, mutations } as IStore<IModuleState>;
